/* eslint-disable @typescript-eslint/ban-ts-comment */
import * as classes from "./iframeDialog.module.css";
// @ts-ignore FIXME: This syntax is used by parcel, need to find a way to validate this in TS
import calendarSvg from "bundle-text:./assets/calendar.svg";
// @ts-ignore FIXME: This syntax is used by parcel, need to find a way to validate this in TS
import searchSvg from "bundle-text:./assets/search.svg";
// @ts-ignore FIXME: This syntax is used by parcel, need to find a way to validate this in TS
import poweredByTT from "bundle-text:./assets/poweredByTT.svg";
// @ts-ignore FIXME: This syntax is used by parcel, need to find a way to validate this in TS
import openbayLogo from "bundle-text:./assets/openbay.svg";

import * as utils from "./utils";

export function createSpinner(): HTMLDivElement {
    const spinnerContainer = document.createElement("div");
    spinnerContainer.className = classes.spinnerContainer;

    const spinner = document.createElement("span");
    spinner.className = classes.spinner;

    spinnerContainer.appendChild(spinner);

    return spinnerContainer;
}

export function createIframe(): HTMLDivElement {
    const iframe = document.createElement("iframe");
    iframe.referrerPolicy = "origin";
    iframe.id = "tt-dialog-iframe";
    iframe.classList.add(classes.iframe);

    const iframeContainer = document.createElement("div");
    iframeContainer.id = "tt-dialog-iframe-container";
    iframeContainer.className = classes.iframeContainer;

    iframeContainer.appendChild(iframe);

    return iframeContainer;
}

function getPartnerLogoInnerHtml(): string {
    const partnerLogos = {
        openbay: openbayLogo,
    };
    const logo = partnerLogos[window.tt.config.partner];
    if (!logo) return "";
    return `<span>+</span>${logo}`;
}

export function renderDialog(): HTMLDialogElement {
    const dialog = document.createElement("dialog");
    dialog.id = "tt-dialog";
    dialog.className = classes.dialog;

    const container = document.createElement("div");
    container.className = classes.dialogContainer;

    const header = document.createElement("div");
    header.className = classes.header;

    const poweredBy = document.createElement("span");
    poweredBy.className = classes.poweredBy;
    poweredBy.innerHTML = poweredByTT + getPartnerLogoInnerHtml();
    poweredBy.addEventListener("click", () => {
        const domain = window.location.hostname;
        const utmContent = encodeURIComponent(document.title);
        const url = `${process.env.POWERED_BY_URL}?utm_source=website-plugin-${domain}&utm_medium=referral&utm_campaign=PoweredbyTT_PluginLink&utm_content=${utmContent}`;
        window.open(url, "_blank");
    });

    const closeIcon = document.createElement("span");
    closeIcon.className = classes.closeIcon;
    closeIcon.innerHTML = "&#x2715;";
    closeIcon.addEventListener("click", () => dialog.close());

    header.appendChild(poweredBy);
    header.appendChild(closeIcon);
    container.appendChild(header);
    dialog.appendChild(container);

    const iframeContainer = createIframe();
    dialog.firstChild.appendChild(iframeContainer);

    document.body.appendChild(dialog);

    return dialog;
}

function configureBaseDialog(dialog: HTMLDialogElement) {
    const iframeContainer = document.getElementById("tt-dialog-iframe-container");
    const iframe = iframeContainer.querySelector("iframe");
    const spinner = createSpinner();
    iframeContainer.appendChild(spinner);
    iframe.classList.add(classes.hideIframe);

    iframe.onload = () => {
        spinner.remove();
        iframe.classList.remove(classes.hideIframe);
        utils.postMessage(iframe);
    };

    dialog.onclose = () => {
        // if dialog is closed before iframe load
        spinner.remove();
    };
}

export function onOpenTireDialog(dialog: HTMLDialogElement) {
    configureBaseDialog(dialog);
    const config = window.tt.config;
    const iframe = document.getElementById("tt-dialog-iframe") as HTMLIFrameElement;
    dialog.classList.add(classes.fullscreen);
    dialog.querySelector(`.${classes.dialogContainer}`).classList.add(classes.fullscreen);
    iframe.src = `${config.iframeBaseUrl}/integrations/dealer-search/${config.dealerId}?searchOnly=true&hideLogo=true&showQuoteLink=true`;
    dialog.showModal();
}

export function onOpenScheduleDialog(dialog: HTMLDialogElement) {
    configureBaseDialog(dialog);
    const config = window.tt.config;
    const iframe = document.getElementById("tt-dialog-iframe") as HTMLIFrameElement;
    dialog.classList.remove(classes.fullscreen);
    dialog.querySelector(`.${classes.dialogContainer}`).classList.remove(classes.fullscreen);
    iframe.src = `${config.iframeBaseUrl}/integrations/dealer-contact/${config.dealerId}`;
    dialog.showModal();
}

export function renderButtons(dialog: HTMLDialogElement) {
    const dialogButtonsConfig = window.tt.config.dialogButtons;

    if (dialogButtonsConfig.hideScheduleButton && dialogButtonsConfig.hideTireButton) return;

    const buttonsContainer = document.createElement("div");
    buttonsContainer.className = classes.buttonsContainer;

    if (!dialogButtonsConfig.hideTireButton) {
        const tireButton = document.createElement("button");
        tireButton.innerHTML = searchSvg;
        tireButton.id = "tt-tire-button";
        const tireText = document.createElement("span");
        tireText.textContent = "Tires";
        tireButton.appendChild(tireText);
        tireButton.className = classes.button;
        buttonsContainer.appendChild(tireButton);
        const handleOpenTireDialog = () => onOpenTireDialog(dialog);
        tireButton.addEventListener("click", handleOpenTireDialog);
    }

    if (!dialogButtonsConfig.hideScheduleButton) {
        const scheduleButton = document.createElement("button");
        scheduleButton.innerHTML = calendarSvg;
        const scheduleText = document.createElement("span");
        scheduleText.textContent = "Service";
        scheduleButton.appendChild(scheduleText);
        scheduleButton.id = "tt-schedule-button";
        scheduleButton.className = classes.button;
        buttonsContainer.appendChild(scheduleButton);
        const handleOpenScheduleDialog = () => onOpenScheduleDialog(dialog);
        scheduleButton.addEventListener("click", handleOpenScheduleDialog);
    }

    document.body.appendChild(buttonsContainer);
}
